import { render, staticRenderFns } from "./ModalCardData.vue?vue&type=template&id=cbcb470c&"
import script from "./ModalCardData.vue?vue&type=script&lang=js&"
export * from "./ModalCardData.vue?vue&type=script&lang=js&"
import style0 from "./ModalCardData.vue?vue&type=style&index=0&id=cbcb470c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports